import { updateCentralSystem } from '@infuse/api/e-connector/central-system';
import { useNotify } from '@infuse/cpms/ui';
import { CentralSystem, mapToApi } from '@infuse/e-connector/central-system/domain';
import { getAxiosErrorMessage } from '@infuse/utils';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useI18n } from 'vue-i18n';

export const useUpdateCentralSystem = () => {
  const queryClient = useQueryClient();
  const { notifySuccess, notifyFailure } = useNotify();
  const { t } = useI18n({ useScope: 'global' });

  return useMutation({
    mutationFn: (centralSystem: CentralSystem) => {
      const apiCentralSystem = mapToApi(centralSystem);
      return updateCentralSystem({ id: apiCentralSystem.id }, apiCentralSystem);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['central-systems'] });

      notifySuccess({
        title: t('e_connector.common.notify.success'),
        message: t('e_connector.centralSystems.notify.update.success')
      });
    },
    onError: (error) => {
      notifyFailure({
        title: t('e_connector.common.notify.error'),
        message: t('e_connector.centralSystems.notify.update.error', {
          reason: getAxiosErrorMessage(error, '')
        })
      });
    }
  });
};
